export * from './consolidated-entries.model';
export * from './daily-entries.model';
export * from './daily-average-by-hour.model';
export * from './date-analysis.model';
export * from './access-logs.model';
export * from './access-by-hour.model';
export * from './occupation-by-hours.model';
export * from './count-by-hour.model';
export * from './count-by-day.model';
export * from './gender-recognition.model';
